import React from 'react';
import TagManager from 'react-gtm-module';
import { useNavigate } from 'react-router-dom';

import * as Sentry from '@sentry/browser';
import { CustomButton } from '../../Button/CustomButton';
import { GetLink } from '../../Common/GetLink';
import { ONECARD } from '../../../constants/constants';

export const CommonError = () => {
  const navigate = useNavigate();
  const retry = () => {
    navigate('/onecardweb');
  };
  // const handleContactUsButton = () => {
  //   window.open('mailto:help@getonecard.app');
  // };

  Sentry.captureMessage('User in Common Error Page');

  const ErrorPage = (
    <>
      <div className="h-auto  pb-5 mt-24  flex flex-col justify-between font-Manrope md:pl-20  w-auto px-0 md:px-5 2xl:mt-44 ">
        <div className=" w-full h-auto flex items-center flex-wrap md:justify-between sm:pr-20 pr-0 ">
          <div className="md:w-auto w-full  flex flex-col items-center md:items-start flex-wrap     ">
            <div className=" w-full flex flex-col h-60 justify-between  ">
              <div className=" w-full">
                <p className="md:text-3xl    text-2xl  px-5 md:px-0 2xl:text-4xl">
                  Oops! we are unable to process your request.
                </p>
                <p className="px-5 md:px-0 mt-3 2xl:text-xl ">
                  Looks like we are facing a temporary issue with the
                  server. Please try again after some time.
                </p>
              </div>
              <div className=" my-5   space-x-5  px-5 md:px-0 ">
                <CustomButton
                  btntext="Retry"
                  isbuttonactive
                  clickEvent={retry}
                />
                {/* <CustomButton
                  btntext="Contacts Us"
                  other="lg:w-40"
                  isbuttonactive
                  clickEvent={handleContactUsButton}
                /> */}
              </div>
            </div>
          </div>

          <div className=" w-full md:w-auto px-5 md:px-0 ">
            <div className="w-full  sm:w-40 h-auto  text-sm ">
              <p className=" text-center mb-3 hidden lg:block  ">
                To download the app
              </p>
              <div className="w-full flex justify-start ">
                <GetLink
                  apptype={ONECARD}
                  textContent="Download Now"
                />
              </div>
              <div className="w-full text-sm   mt-2 hidden lg:block mb-0 sm:mb-2">
                <p className=" text-center ">OR</p>
              </div>
              <div className="hidden lg:block ">
                <div className="h-40 w-full border border-confirmbtn-500 flex justify-center items-center rounded-xl shadow-2xl bg-black  ">
                  <img
                    alt="QR Code"
                    src="https://www.getonecard.app/assets/apply/qr_oc.svg"
                    className="h-32 w-32 "
                  />
                </div>
              </div>
              <p className=" text-center mt-2 hidden lg:block">
                Scan QR
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  TagManager.initialize({
    gtmId: `GTM-${process.env.REACT_APP_GTMID}`,
    auth: process.env.REACT_APP_GTMAUTH,
    preview: process.env.REACT_APP_GTMENV,
    dataLayer: {
      page: 'commonErrorPage',
    },
    dataLayerName: 'errorDataLayer',
  });
  return ErrorPage;
};
